import { useState } from 'react';
import './styles.scss'

export default function Card(props) {

    const [label, setLabel] = useState('Copy URL')

    const span = () => {
        if(props.fullwidth) return '-1/1'
        if(props.spanTwo) return 'span 2'
        return 'auto'
    }

    const copy = (e) => {
        e.preventDefault()

        navigator.clipboard.writeText(`https://sigma-plugins.zero.health/${props.path}`).then(() => {
            setLabel('Copied!')
            setTimeout(() => setLabel('Copy URL'), 4000)
        })
    }

    return (
        <div className='ui-card' style={{
            gridColumn: span()
        }}>
            <div className='card-content'>
                {props.children}
            </div>

            <footer>
                <span>{props.title ?? 'Untitled'}</span>
                <a href={`https://sigma-plugins.zero.health/${props.path}`} onClick={copy}>{label}</a>
            </footer>
        </div>
    )
}